import { StyleProvider } from "@ant-design/cssinjs";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ConfigProvider, theme } from "antd";
import { ReactNode } from "react";
import NotificationProvider from "./notification.provider";
import { CustomizeRequiredMark } from "~/components/common/custom-required-mark";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes - data is considered fresh for 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes - cache garbage collection time (formerly cacheTime)
      retry: (failureCount, error) => {
        // Don't retry on 4xx errors, but retry on network/server errors up to 3 times
        const status = (error as any)?.response?.status ?? (error as any)?.status;
        if (status && status >= 400 && status < 500) {
          return false;
        }
        return failureCount < 3;
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff
    },
    mutations: {
      retry: false, // Don't retry mutations by default
    },
  },
});

const RootProvider = ({ children }: { children: ReactNode }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <StyleProvider layer>
        <ConfigProvider
          theme={{
            algorithm: theme.defaultAlgorithm,
            components: {
              Form: {
                // itemMarginBottom: 0,
              },
            },
          }}
          form={{
            requiredMark: CustomizeRequiredMark,
            scrollToFirstError: true,
          }}
        >
          <NotificationProvider>{children}</NotificationProvider>
        </ConfigProvider>
      </StyleProvider>
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  );
};

export default RootProvider;
